<template>
    <v-footer app color="grey lighten-1">
        <v-spacer></v-spacer>
        <span class="overline">&copy; {{ new Date().getFullYear() }} SECRETARÍA GENERAL - Sistema de Control Presupuestal V.1.0</span>
    </v-footer>
</template>

<script>
export default {
    data: () => ({
        loading: false,
    })
}
</script>